import PermanentError from "@/utils/errors/PermanentError"

export class FoodStoreLevelError extends PermanentError {
}


type FoodProductLevelErrorData = {
  productId: string
  error: string
}[]

export class FoodProductLevelError extends PermanentError {
  data: FoodProductLevelErrorData
  constructor(data: FoodProductLevelErrorData) {
    super()
    this.data = data
  }
}
